import {
  deMessages,
  enMessages,
  esMessages,
  frMessages,
  itMessages,
  ptMessages,
  skMessages,
} from '../../../pdf-design-system/locale';

import { messages as deTemplateMessages } from './de';
import { messages as enTemplateMessages } from './en';
import { messages as esTemplateMessages } from './es';
import { messages as frTemplateMessages } from './fr';
import { messages as itTemplateMessages } from './it';
import { messages as ptTemplateMessages } from './pt';
import { messages as skTemplateMessages } from './sk';

const catalog = {
  en: { ...enMessages, ...enTemplateMessages },
  de: { ...deMessages, ...deTemplateMessages },
  es: { ...esMessages, ...esTemplateMessages },
  fr: { ...frMessages, ...frTemplateMessages },
  it: { ...itMessages, ...itTemplateMessages },
  pt: { ...ptMessages, ...ptTemplateMessages },
  sk: { ...skMessages, ...skTemplateMessages },
};

export default catalog;
